import React from 'react';
import { useParams } from 'react-router-dom';
import CallCenter from '../../components/CallCenter';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Lnb from '../../components/Lnb';
import Location from '../../components/Location';

type Params = {
    resultCode: string;
}

const PsychlngclCheckDepressionResult: React.FC = () => {
    const {resultCode} = useParams<Params>();
    const viewResult = (resultCode: string) => {
        switch(resultCode) {
            case "001" :
                return (
                    <>
                        <p className="result">님은 우울 점수는 낮은 편입니다.</p>
                        <p>사람들은 누구나 우울할 때가 있습니다.
                            <br />실망스러운 일이 있거나, 힘든 일이 있을 때 슬프고 기분이 가라앉는 것은 아주 자연스러운 현상입니다.
                            <br />다만 지나치게 오랫동안 지속되거나, 일상 생활에 방해가 되지 않도록 관리하는 것이 중요합니다. 
                        </p>
                        <div className="tip">
                            <p><span>우울감 줄이기 tip</span></p>
                            <ul className="li_common mt20">
                                <li>무조건 숨기기보다 의지할 수 있는 사람에게 표현하기</li>
                                <li>하루종일 우울함에 빠져있기보다 활력을 주는 다른 활동하기</li>
                                <li>전문가와의 상담을 통해 우울감 극복하기</li>
                            </ul>
                        </div>
                    </>
                )
            case "002" :
                return (
                    <>
                        <p className="result">님은 우울 점수는 보통입니다.</p>
                        <p>때때로 우울감을 느끼는 것은 아주 자연스러운 일입니다.
                            <br />그러나 만약 2주 이상 우울한 기분이 지속되고, 이로 인해 가족이나 대인관계, 직장에서 역할을 하는데 지장이 있다면 전문가의 도움을 받는 것이 좋습니다. 
                            <br />우울증은 누구에게나 찾아올 수 있기 때문에 평소 자신의 상태를 잘 살피는 것이 중요합니다. 많은 경우 우울증은 내 안의 목소리에 영향을 받습니다.
                            <br />자신감이 떨어지고 의욕이 줄어들 때, 스스로에게 힘을 줄 수 있다면 우울감을 보다 쉽게 극복할 수 있습니다.
                        </p>
                        <div className="tip">
                            <p><span>내 안의 목소리 키우기 tip</span></p>
                            <ul className="li_common mt20">
                                <li>하루 3번씩 스스로 칭찬하기</li>
                                <li>잘한 일에는 작은 상 주기</li>
                                <li>있을 수 있는 실수에 관대하기</li>
                                <li>전문가와의 상담을 통해 성장하기</li>
                            </ul>
                        </div>
                    </>
                )
            case "003" :
                return (
                    <>
                        <p className="result">님은 우울 점수는 높은 편입니다.</p>
						<p>
                            우울감이 심해지면 식사나 수면, 대인관계에도 영향을 미치고, 일상생활이 어렵게 느껴지므로 빨리 전문가의 도움을 받는 것이 좋습니다.
                            <br />의욕이 떨어져 맡은 일이나 대인관계에서 실수를 하게 되고, 실수에 대해 스스로 자책하는 악순환으로 인해 우울감이 더 심해지기도 합니다. 
                        </p>
						<br />
						<p>
                            우울증은 누구에게나 찾아올 수 있으며, 적극적으로 대처할수록 빨리 극복할 수 있습니다. 괜찮아지리라는 막연한 생각으로 방치해서는 안됩니다. <br />
                            우울증을 극복하기 위해서는 내 생각과 감정의 굴레를 벗어나는 것이 중요합니다. 혼자서는 이 굴레에서 벗어나기가 어렵기 때문에 전문가의 도움이 꼭 필요합니다. 
                        </p>
                    </>
                )
        }
    }

    return (
        <div id="warp">
            <Header />
            <section id="containers">
                <div className='therapy'>
                    <Lnb />
                    <div id="contents" className='contents'>
                        <h2>무료심리검사</h2>
                        <Location locations={[
                            {title: "토닥토닥마음케어", url: "/column/columnList"}
                            , {title: "무료심리검사", url: "/psychlgclCheck/main"}]} 
                            menuName='우울 자가진단'
                        />
                        <div className='mobileface testing'>
                            <div className="resultWrap depression">
                                <h3 className="f18 black">우울 자가진단</h3>
                                <h4 className="f14 green mt30">우울 자가진단 결과</h4>
                                <div className="total">
									{
                                        resultCode? (
                                            viewResult(resultCode)
                                        ) : (
                                            viewResult("001")
                                        )
                                    }
								</div>
                                <CallCenter />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default PsychlngclCheckDepressionResult;